import { useParams } from "react-router-dom";
import { ChatComponent } from "../../components/chat/chat.component";
import { AcceptJobRequestResult } from "../../store/Jobs/job.store";

interface VendorJobRequestChannelPageProps {
	organizationId: string;
	userId: string;
	clientOrganizationIds: string[];
	onShareFile: (fileId: string) => Promise<void>;
	onUnshareFile: (fileId: string) => Promise<void>;
	onAcceptJobRequest: (
		channelId: string | null
	) => Promise<AcceptJobRequestResult>;
	onDenyJobRequest: (channelId: string | null) => Promise<boolean>;
}

export const VendorJobRequestChannelPage: React.FC<
	VendorJobRequestChannelPageProps
> = ({
	organizationId,
	userId,
	clientOrganizationIds,
	onShareFile,
	onUnshareFile,
	onAcceptJobRequest,
	onDenyJobRequest,
}) => {
	const { channelId } = useParams<{ vendorId: string; channelId: string }>();

	if (!organizationId || !userId || !channelId) {
		return <div></div>;
	}

	return (
		<div className="h-full flex">
			<div className="flex-1 bg-white">
				<ChatComponent
					organizationId={organizationId}
					channelId={channelId}
					onShareFile={onShareFile}
					onUnshareFile={onUnshareFile}
					onAcceptJobRequest={onAcceptJobRequest}
					onDenyJobRequest={onDenyJobRequest}
					clientOrganizationIds={clientOrganizationIds}
					allowGoTo={true}
					checkForClientConnectionToCustomer={false}
				/>
			</div>
		</div>
	);
};
